import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUserSettings } from 'common/redux/userSettings/userSettingsSlice';
import {
  getShowCookiesBanner,
  setPerformanceCookie,
} from '../../common/services/userCookiesService';

export const useCookieBanner = () => {
  const dispatch = useDispatch();
  const token = sessionStorage.getItem('jwtToken');
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    if (token) {
      // eslint-disable-next-line no-void
      void (async () => {
        const showBanner = await getShowCookiesBanner();
        setShowCookieBanner(showBanner);
      })();
    }
  }, [token]);

  const setCookies = async (allowCookies: boolean) => {
    const isSuccessFull = await setPerformanceCookie(allowCookies);
    dispatch(
      setUserSettings({
        allowPerformanceCookies: allowCookies,
      })
    );
    if (isSuccessFull) {
      setShowCookieBanner(false);
    }
  };

  return {
    showCookieBanner,
    setCookies,
  };
};
